import {Button, CircularProgress, Grid, TextField, Typography} from '@material-ui/core';
import GuidTextInput from 'BOSTools/components/GuidTextInput';
import {changeApplicationStatus, getApplicationStatusBySceneID, updateApplicationStatus} from 'BOSTools/ducks/bosTools';
import {InvalidGuid, ValidGuid} from 'BOSTools/models/Guid';
import {isLoaded, Loaded, ServerError} from 'Core/models/Async';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';

const ApplicationStatusUpdate = () => {
  const dispatch = useDispatch();

  const {applicationStatus} = useSelector((state: ReducerState) => state.bostools);
  const [sceneID, setSceneID] = useState(
    isLoaded(applicationStatus) ? applicationStatus.Data.sceneID : ValidGuid.create('')
  );

  return (
    <Grid container direction="column" spacing={4}>
      <>
        <Grid item>
          <GuidTextInput
            id="sceneID"
            label="Scene ID"
            guid={sceneID}
            onChange={e => setSceneID(ValidGuid.create(e.target.value))}
          />
        </Grid>
        <Grid item container justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            disabled={sceneID instanceof InvalidGuid}
            onClick={() => dispatch(getApplicationStatusBySceneID(sceneID as ValidGuid))}
          >
            Search
          </Button>
        </Grid>
        {isLoaded(applicationStatus) ? (
          <>
            <Grid item>
              <TextField
                fullWidth
                variant="outlined"
                label="Scene ID"
                value={applicationStatus.Data.sceneID.value}
                disabled
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                variant="outlined"
                label="Status"
                required
                type="number"
                value={applicationStatus.Data.status}
                onChange={e =>
                  dispatch(
                    changeApplicationStatus(
                      new Loaded({...applicationStatus.Data, status: parseInt(e.target.value, 10)})
                    )
                  )
                }
              />
            </Grid>
            <Grid item container justify="flex-end">
              <Button
                color="primary"
                variant="contained"
                disabled={!applicationStatus.Data.status}
                onClick={() =>
                  dispatch(
                    updateApplicationStatus(applicationStatus.Data.sceneID as ValidGuid, applicationStatus.Data.status!)
                  )
                }
              >
                Update Status
              </Button>
            </Grid>
          </>
        ) : applicationStatus.key === 'Loading' ? (
          <div className="bostools_form__loading-container">
            <CircularProgress color="primary" />
          </div>
        ) : (
          ['ServerError', 'NotFound'].includes(applicationStatus.key) && (
            <Grid item>
              <Typography variant="body1">
                {(applicationStatus as ServerError).errorDetails || (applicationStatus as ServerError).message}
              </Typography>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default ApplicationStatusUpdate;
